module.exports = __webpack_public_path__ + "static/img/labour-love-4.0553e59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/labour-love-4.svg
// module id = /idM
// module chunks = 1